<div class="common-alarm-group" fxLayout="row" fxLayoutAlign="space-between center" >
  <div>New alarm 128, <b>Accident</b> at <b>Commonwealth Avenue</b></div>
  <button mat-button class="mar-left-10" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>